import { render, staticRenderFns } from "./SeriesDetail.vue?vue&type=template&id=74a07f25&scoped=true&"
import script from "./SeriesDetail.vue?vue&type=script&lang=js&"
export * from "./SeriesDetail.vue?vue&type=script&lang=js&"
import style0 from "../../style.css?vue&type=style&index=0&id=74a07f25&prod&scoped=true&lang=css&"
import style1 from "./SeriesDetail.vue?vue&type=style&index=1&id=74a07f25&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a07f25",
  null
  
)

export default component.exports